import { useState } from 'react'
import { ButtonLegacy } from '@/components/ui/button-legacy'
import { Edit03Icon } from '@/components/ui/icons'
import { ServiceVettingCriteriaChoosePhotoModal } from '@/features/service-vetting/components/service-vetting-criteria-choose-photo-modal'
import { useUpdateMainPhotoOffering } from '@/features/service-vetting/query/use-update-main-photo-offering.ts'
import { useTranslation } from '@/translations/i18n'

export const ServiceVettingCriteriaEditOfferingPhotoButton = ({
	offeringTitle,
	offeringId,
	serviceId,
	galleryId,
	currentSelectedImageId
}: {
	offeringTitle: string
	offeringId: number
	serviceId: number
	galleryId: number
	currentSelectedImageId?: number
}) => {
	const { t } = useTranslation()
	const [showModal, setShowModal] = useState(false)
	const updateMainPhotoOffering = useUpdateMainPhotoOffering(
		{ offeringId, serviceId },
		{
			onSuccess: () => {
				setShowModal(false)
			}
		}
	)

	const onConfirm = (id: number) => {
		updateMainPhotoOffering.mutate({ imgId: id })
	}
	return (
		<>
			<ButtonLegacy
				onClick={() => setShowModal(true)}
				size={'sm'}
				type='button'
				variant={'tertiary'}
			>
				<Edit03Icon />
				{t('common:edit')}
			</ButtonLegacy>
			{showModal && (
				<ServiceVettingCriteriaChoosePhotoModal
					currentSelectedImageId={currentSelectedImageId}
					galleryId={galleryId}
					isPending={updateMainPhotoOffering.isPending}
					onClose={() => setShowModal(false)}
					onConfirm={onConfirm}
					serviceId={serviceId}
					title={t(
						'vetting:criteria.service.offerings.edit_offering_photo',
						{ type: offeringTitle }
					)}
				/>
			)}
		</>
	)
}
